/**
 * Decodes a VIN using the NHTSA VPIC API
 * @param {string} vin - 17 character VIN
 * @returns {Promise<Object>} Vehicle data object with year, make, model, trim
 */
export const decodeVIN = async (vin) => {
  if (!vin || vin.length !== 17) {
    throw new Error('VIN must be 17 characters');
  }

  try {
    const response = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/${vin}?format=json`);
    const data = await response.json();
    
    if (data.Results) {
      const results = data.Results.reduce((acc, item) => {
        acc[item.Variable] = item.Value;
        return acc;
      }, {});
      
      const vehicleData = {
        year: results['Model Year'] || '',
        make: results['Make'] || '',
        model: results['Model'] || '',
        trim: results['Trim'] || ''
      };
      
      return vehicleData;
    }
    
    throw new Error('No vehicle data found');
  } catch (error) {
    throw new Error(`Error decoding VIN: ${error.message}`);
  }
};

